import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navigator" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "navigator-link" }
const _hoisted_5 = { class: "navigator-link-policy-box" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

import { useRouter } from 'vue-router';
import icons from '@/icons';

export default /*@__PURE__*/_defineComponent({
  __name: 'NavigatorComponent',
  setup(__props) {

const router = useRouter();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: {
        name: 'FAQView',
        params: {
          tenant_uuid: _unref(router).currentRoute.value.params.tenant_uuid,
          insuree_uuid: _unref(router).currentRoute.value.params.insuree_uuid,
        },
      },
      class: "navigator-link info-text-list-bold"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "navigator-link-icon",
          innerHTML: _unref(icons).faq
        }, null, 8, _hoisted_2),
        _cache[0] || (_cache[0] = _createTextVNode(" FAQ "))
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode(_component_router_link, {
      to: {
        name: 'ContactView',
        params: {
          tenant_uuid: _unref(router).currentRoute.value.params.tenant_uuid,
          insuree_uuid: _unref(router).currentRoute.value.params.insuree_uuid,
        },
      },
      class: "navigator-link info-text-list-bold"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "navigator-link-icon",
          innerHTML: _unref(icons).callIcon
        }, null, 8, _hoisted_3),
        _cache[1] || (_cache[1] = _createTextVNode(" Contact "))
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: {
            name: 'PolicyView',
            params: {
              tenant_uuid: _unref(router).currentRoute.value.params.tenant_uuid,
              insuree_uuid: _unref(router).currentRoute.value.params.insuree_uuid,
            },
          },
          class: "navigator-link-policy"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "navigator-link-icon",
              innerHTML: _unref(icons).policyIcon
            }, null, 8, _hoisted_6)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createVNode(_component_router_link, {
      to: {
        name: 'ActivityView',
        params: {
          tenant_uuid: _unref(router).currentRoute.value.params.tenant_uuid,
          insuree_uuid: _unref(router).currentRoute.value.params.insuree_uuid,
        },
      },
      class: "navigator-link info-text-list-bold"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "navigator-link-icon",
          innerHTML: _unref(icons).securityIcon
        }, null, 8, _hoisted_7),
        _cache[2] || (_cache[2] = _createTextVNode(" Activity "))
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode(_component_router_link, {
      to: {
        name: 'MenuView',
        params: {
          tenant_uuid: _unref(router).currentRoute.value.params.tenant_uuid,
          insuree_uuid: _unref(router).currentRoute.value.params.insuree_uuid,
        },
      },
      class: "navigator-link info-text-list-bold"
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "navigator-burger" }, [
          _createElementVNode("div", { class: "navigator-burger-line" }),
          _createElementVNode("div", { class: "navigator-burger-line" }),
          _createElementVNode("div", { class: "navigator-burger-line" })
        ], -1),
        _createTextVNode(" More ")
      ])),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})